// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"47e87259","455":"73a0c62a","977":"4a4e8e84"}[chunkId] + ".chunk.js";
};